import { render } from "./SummaryLesson.vue?vue&type=template&id=579db374&scoped=true"
import script from "./SummaryLesson.vue?vue&type=script&lang=js"
export * from "./SummaryLesson.vue?vue&type=script&lang=js"

import "./SummaryLesson.vue?vue&type=style&index=0&id=579db374&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579db374"]])

export default __exports__